import React from 'react';

export default function TableContent({
  data = [],
  fieldFilter = [],
  selectedFieldFilter = [],
  draggedFieldOrder = [],
}) {
  const columns =
    draggedFieldOrder.length > 0 ? draggedFieldOrder : selectedFieldFilter;

  return (
    <tbody>
      {data.length === 0 ? (
        <tr>
          <td colSpan={columns.length}>
            <div className="div-flex-row div-align-center">
              <span className="text-md text-400">No results found</span>
            </div>
          </td>
        </tr>
      ) : (
        data.map((row) => (
          <tr key={row.vehicle_tracking_number}>
            {columns.map((fieldValue) => {
              const matchedField = fieldFilter.find(
                (f) => f.value === fieldValue,
              );
              const fieldKey = matchedField?.key;
              const value = row[fieldKey];

              if (
                Array.isArray(value) &&
                (fieldKey === 'po_number' || fieldKey === 'supplier_name')
              ) {
                return (
                  <td key={fieldValue} className="table-cell-min-width-150">
                    <div className="text-md text-400">
                      {value.length > 0 ? (
                        value.map((item) => (
                          <div key={`${fieldKey}_${item}`}>{item}</div>
                        ))
                      ) : (
                        <div>-</div>
                      )}
                    </div>
                  </td>
                );
              }

              return (
                <td key={fieldValue} className="table-cell-min-width-150">
                  <div className="text-md text-400">
                    {value !== null && value !== undefined && value !== ''
                      ? value
                      : '-'}
                  </div>
                </td>
              );
            })}
          </tr>
        ))
      )}
    </tbody>
  );
}
